'use client';

import { makeJobOfferDeeplink } from '@/utils/deeplink';
import { JobOfferFragment } from '../gen/graphql/JobRoute.generated';
import { JobOfferListItem } from './JobOfferListItem';
import { useAppNavigationDialog } from '@/components/features/AppNavigationDialog/useAppNavigationDialog';
export interface JobOffersProps {
  offers: JobOfferFragment[];
}

export function JobOffers({ offers }: JobOffersProps) {
  const { navigate, Dialog } = useAppNavigationDialog();

  const handleClick = (offer: JobOfferFragment) => {
    navigate(makeJobOfferDeeplink(offer.id));
  };

  return (
    <div className="flex flex-row flex-wrap border-b-thin border-neutral-auxiliary-tinge gap-3 py-10">
      {offers.map((offer) => (
        <JobOfferListItem key={offer.id} offer={offer} onClick={handleClick} />
      ))}
      {Dialog}
    </div>
  );
}
